export const CONSENT_KEY = 'felgocar_cookie_consent_v2';
export const COOKIE_SETTINGS_EVENT = 'felgocar:cookie-settings';

export type CookiePreferences = { analytics: boolean; advertising: boolean };
export type CookieConsentState = CookiePreferences & { decided: boolean };

export function readCookieConsent(): CookieConsentState {
  if (typeof window === 'undefined') return { analytics: false, advertising: false, decided: false };
  try {
    const saved = JSON.parse(window.localStorage.getItem(CONSENT_KEY) || 'null');
    if (saved?.version === 2 && typeof saved.analytics === 'boolean' && typeof saved.advertising === 'boolean') {
      return { analytics: saved.analytics, advertising: saved.advertising, decided: true };
    }
  } catch { /* Missing, malformed or unavailable storage must not grant consent. */ }
  try {
    const legacy = window.localStorage.getItem('felgocar_cookie_consent');
    // The old banner described analytics only. Never infer advertising consent from it.
    return { analytics: legacy === 'all', advertising: false, decided: legacy === 'necessary' };
  } catch {
    return { analytics: false, advertising: false, decided: false };
  }
}

export function saveCookieConsent(preferences: CookiePreferences): void {
  const analytics = preferences.analytics === true;
  const advertising = preferences.advertising === true;
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify({ version: 2, analytics, advertising }));
    window.localStorage.setItem('felgocar_cookie_consent', analytics ? 'all' : 'necessary');
  } catch { /* Apply the current choice even when the browser cannot persist it. */ }
  window.gtag?.('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: advertising ? 'granted' : 'denied',
    ad_user_data: advertising ? 'granted' : 'denied',
    ad_personalization: advertising ? 'granted' : 'denied',
  });
}

export function openCookieSettings(): void {
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
}
